import { Injectable } from '@angular/core';

import { objectToQueryString } from '../../common/utils';

import { environment } from '../../../environments/environment';

import { RestService } from './rest.service';

@Injectable()
export class LocalService {
  constructor(private readonly rest: RestService) {}

  getLocals(search: string = ''): Promise<any> {
    const query = objectToQueryString({
      search,
    });

    return this.rest.get(`${environment.apiUrl}/api/core/local${query}`);
  }

  getLocalById(id: number): Promise<any> {
    return this.rest.get(`${environment.apiUrl}/api/core/local/${id}`);
  }

  createLocal(payload: any): Promise<any> {
    return this.rest.post(`${environment.apiUrl}/api/core/local`, payload);
  }

  updateLocal(id: number, payload: any): Promise<any> {
    return this.rest.put(`${environment.apiUrl}/api/core/local/${id}`, payload);
  }

  deleteLocal(id: number): Promise<any> {
    return this.rest.delete(`${environment.apiUrl}/api/core/local/${id}`);
  }
}
